import {
  UIComponents,
  UIActions,
  ActionWindowParams,
  ViewState,
  Action,
  WindowRegistry,
  NtapGlobalConstants,
  Util
} from '@ntap/core';
import { ViewResult } from '@ntap/core/lib/view/view-result';
import { Observable } from 'rxjs';
import { EarhivUiComponents } from '../models/earhiv-ui-components';

// FIXME - ova klasa ne bi trebala biti potrebna. Ili barem ne bi trebalo biti potrebno overridati ovoliko koda
// to je problem u platformi pa kad se riješi da bude konfigurabilno koja akcija otvara dialog treba maknuti klasu

const OPEN_ITEM_DIALOG_ACTIONS = [
  UIComponents.ACTION_OPEN_ITEMVIEW,
  UIComponents.ACTION_OPEN_LISTVIEW,
  UIActions.NEW_ITEM,
  EarhivUiComponents.NEW_JEDINICA_GRADIVA_ACTION,
  EarhivUiComponents.NEW_IZLUCIVANJE_ACTION,
  EarhivUiComponents.NEW_PREDAJA_ACTION,
  EarhivUiComponents.OPEN_ITEM_VIEW_ACTION,
  EarhivUiComponents.DOSTAVA_JEDINICA_ACTION,
  EarhivUiComponents.OPEN_NESTED_VIEW_ACTION,
  EarhivUiComponents.NEW_FOLDER_ACTION,
  EarhivUiComponents.EDIT_JEDINICA_GRADIVA_DOKUMENTACIJA,
  EarhivUiComponents.OPEN_ARHIV_POSJEDNIK_FROM_JEDINICA_GRADIVA_ACTION,
  EarhivUiComponents.OPEN_POVEZANA_JEDINICA_GRADIVA_ACTION,
  EarhivUiComponents.OPEN_POVEZANI_AGENT_ACTION,
  EarhivUiComponents.OPEN_POVEZANO_MJESTO_ACTION,
  EarhivUiComponents.PROMIJENI_LOKACIJU_FIZICKI_OBJEKTI_ACTION,
  EarhivUiComponents.POSTAVI_STATUS_OTPREME_ACTION,
  EarhivUiComponents.OPEN_KORISNIK_CITAONICE,
  EarhivUiComponents.OPEN_KONVERZIJA_POJAVNI_OBLIK_ACTION,
  EarhivUiComponents.OPEN_GENERATOR_URBROJ_ACTION
];

const ITEM_VIEW_ACTIONS = [
  UIComponents.ACTION_OPEN_ITEMVIEW,
  UIActions.NEW_ITEM,
  EarhivUiComponents.NEW_JEDINICA_GRADIVA_ACTION,
  EarhivUiComponents.NEW_OBJEKTI_POJAVNOG_OBLIKA_ACTION,
  EarhivUiComponents.NEW_CHILD_ENTITY_ACTION,
  EarhivUiComponents.NEW_IZLUCIVANJE_ACTION,
  EarhivUiComponents.NEW_PREDAJA_ACTION,
  EarhivUiComponents.OPEN_ITEM_VIEW_ACTION,
  EarhivUiComponents.DOSTAVA_JEDINICA_ACTION,
  EarhivUiComponents.DEDUPLICATE_LIST_ITEMS_ACTION,
  EarhivUiComponents.OPEN_NESTED_VIEW_ACTION,
  EarhivUiComponents.NEW_FOLDER_ACTION,
  EarhivUiComponents.EDIT_JEDINICA_GRADIVA_DOKUMENTACIJA,
  EarhivUiComponents.OPEN_ARHIV_POSJEDNIK_FROM_JEDINICA_GRADIVA_ACTION,
  EarhivUiComponents.OPEN_POVEZANA_JEDINICA_GRADIVA_ACTION,
  EarhivUiComponents.OPEN_POVEZANI_AGENT_ACTION,
  EarhivUiComponents.OPEN_POVEZANO_MJESTO_ACTION,
  EarhivUiComponents.PROMIJENI_LOKACIJU_FIZICKI_OBJEKTI_ACTION,
  EarhivUiComponents.POSTAVI_STATUS_OTPREME_ACTION,
  EarhivUiComponents.OPEN_KORISNIK_CITAONICE,
  EarhivUiComponents.DEDUPLICATE_MJESTO_LIST_ITEMS_ACTION,
  EarhivUiComponents.OPEN_KONVERZIJA_POJAVNI_OBLIK_ACTION,
  EarhivUiComponents.OPEN_GENERATOR_URBROJ_ACTION
];

export class OpenArhivWindowActionUtil {
  static open(
    params: ActionWindowParams,
    viewState: ViewState
  ): Observable<ViewResult> {
    OpenArhivWindowActionUtil.addItemTypeParams(viewState, params.openItemType);
    return params.window.open(
      params.viewName,
      viewState,
      params.compId,
      params.isItemView
    );
  }

  static createParams(
    action: Action,
    registry: WindowRegistry,
    windowTarget: string
  ): ActionWindowParams {
    const params = {
      viewName: OpenArhivWindowActionUtil.getActionOpenViewName(action),
      compId: action.open_ui_compid,
      openItemType: action.$openItemType,
      // isDialog: this.isOpenItemAction(action),
      window: registry.getWindow(windowTarget),
      isItemView: this.isItemViewAction(action)
    } as ActionWindowParams;
    return params;
  }

  private static getActionOpenViewName(action: Action): string {
    const openViewName = action.$openViewName;
    if (!openViewName) {
      throw new Error(
        `Action view name required but not defined: ${action.name}`
      );
    }
    return openViewName;
  }

  private static addItemTypeParams(viewState: any, openItemType?: string) {
    if (openItemType) {
      const itemType = viewState[NtapGlobalConstants.ATTR_$itemType];
      if (openItemType != itemType) {
        viewState[NtapGlobalConstants.ATTR_$itemType] = openItemType;
        const itemIdAttr = Util.getFullAttrName(
          openItemType,
          NtapGlobalConstants.ATTR_id
        );
        if (!viewState[itemIdAttr]) {
          viewState[itemIdAttr] = NtapGlobalConstants.ID_NEW;
        }
      }
    }
  }

  private static isOpenItemAction(action: Action): boolean {
    // Ovo je privremeno, dok jos razlikujemo item/list komponente.
    return OPEN_ITEM_DIALOG_ACTIONS.indexOf(action.ui_component) > -1;
  }

  private static isItemViewAction(action: Action): boolean {
    // Ovo je privremeno, dok jos razlikujemo item/list komponente.
    return ITEM_VIEW_ACTIONS.indexOf(action.ui_component) > -1;
  }
}
